<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs :crm_id="this.$route.params.crmid"/>
        <div class="table-agile-info">
          <el-tabs :before-leave="checkTab" v-model="activeName" @tab-click="tableDataChange">
            <el-tab-pane v-for="item in projectList" :key="item.id" :label="item.name" :name="item.namespace" :project-id="item.id"></el-tab-pane>
          </el-tabs>
          <!--高考日语部分列表条件 start-->
          <div v-show="activeName === 'gkry'">
            <gkry-search-data ref="gkry" :search-data.sync="searchData"></gkry-search-data>
          </div>
          <!--高考日语部分列表条件 end-->
          <!--考试培训部分列表条件 start-->
          <div v-show="activeName === 'training'">
            <training-search-data ref="training" :search-data.sync="searchData"></training-search-data>
          </div>
          <!--考试培训部分列表条件 end-->
          <!--芥末留学部分列表条件 start-->
          <div v-show="activeName === 'jiemo'">
            <jiemo-search-data ref="jiemo" :search-data.sync="searchData"></jiemo-search-data>
          </div>
          <!--芥末留学部分列表条件 end-->
          <!--前程日本部分列表条件 start-->
          <div v-show="activeName === 'qcrb'">
            <qcrb-search-data ref="qcrb" :search-data.sync="searchData"></qcrb-search-data>
          </div>
          <!--前程日本部分列表条件 end-->
          <!--日语考级部分列表条件 start-->
          <div v-show="activeName === 'nseries'">
            <nseries-search-data ref="nseries" :search-data.sync="searchData"></nseries-search-data>
          </div>
          <!--日语考级部分列表条件 end-->
          <div class="searchBottom">
            <el-button
              class="jm-input-common3"
              type="primary"
              @click="search()">搜索</el-button>
            <el-button
              class="jm-input-common3"
              type="default"
              @click="resetFields">重置</el-button>
          </div>
          <!--列表部分 start -->
          <jm-tableList
            :url="getListurl"
            :search-data="searchData"
            ref="tableList"
          >
            <el-table-column
              slot="order_title"
              label="订单名称">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.order_title }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.order_title }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="apply_school_list"
              label="所申学校">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ schoolFormat(scope.row.apply_school_list) }}
                  <span slot="reference" class="white-nowrap">{{ schoolFormat(scope.row.apply_school_list) }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="order_memo"
              label="订单备注">
              <template slot-scope="scope">
                <el-popover
                  placement="top"
                  width="200"
                  trigger="hover">
                  {{ scope.row.order_memo }}
                  <span slot="reference" class="white-nowrap">{{ scope.row.order_memo }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              slot="lastColumn"
              fixed="right"
              align="center"
              header-align="center"
              width="140"
              label="操作">
              <template slot-scope="scope">
                <div v-show="searchData.project_id === 10">
                  <router-link
                    target="_blank"
                    :to="{ name: 'gkryOrderDetail', params: { id:scope.row.id }}">
                    <el-button
                      type="primary"
                      size="small">查看详情</el-button>
                  </router-link>
                  <el-button
                    type="primary"
                    size="small"
                    @click="search({ student_id: scope.row.student_id })">查看历史</el-button>
                </div>
                <div v-show="searchData.project_id === 11">
                  <router-link
                    target="_blank"
                    :to="{ name: 'trainingOrderDetail', params: { id:scope.row.id }}">
                    <el-button
                      type="primary"
                      size="small">查看详情</el-button>
                  </router-link>
                  <el-button
                    type="primary"
                    size="small"
                    @click="search({ userid: scope.row.userid })">查看历史</el-button>
                </div>
                <div v-show="searchData.project_id === 12">
                  <router-link
                    target="_blank"
                    :to="{ name: 'jiemoOrderDetail', params: { id: scope.row.id }}">
                    <el-button
                      type="primary"
                      size="small">查看详情</el-button>
                  </router-link>
                  <el-button
                    type="primary"
                    size="small"
                    @click="search({ crm_id: scope.row.crm_id })">查看历史</el-button>
                </div>
                <div v-show="searchData.project_id === 13">
                  <router-link
                    target="_blank"
                    :to="{ name: 'qcrbOrderDetail', params: { id: scope.row.id }}">
                    <el-button
                      type="primary"
                      size="small">查看详情</el-button>
                  </router-link>
                  <el-button
                    type="primary"
                    size="small"
                    @click="search({ crm_id: scope.row.crm_id })">查看历史</el-button>
                </div>
                <div v-show="searchData.project_id === 14">
                  <router-link
                    target="_blank"
                    :to="{ name: 'nseriesOrderDetail', params: { id: scope.row.big_order_id }}">
                    <el-button
                      type="primary"
                      size="small">查看详情</el-button>
                  </router-link>
                  <el-button
                    v-if="scope.row.userid > 0"
                    type="primary"
                    size="small"
                    @click="search({ userid: scope.row.userid })">查看历史</el-button>
                </div>
              </template>
            </el-table-column>
          </jm-tableList>
          <!--列表部分 end-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList';
import gkrySearchData from './compoments/gkrySearchData';
import trainingSearchData from './compoments/trainingSearchData';
import jiemoSearchData from './compoments/jiemoSearchData';
import qcrbSearchData from './compoments/qcrbSearchData';
import nseriesSearchData from './compoments/nseriesSearchData';

export default {
  data() {
    return {
      activeName: 'gkry', // 当前项目
      activePid: 10,
      projectList: [],
      searchData: {
        sign_order_no: '',
        title: '',
        last_payment_time: [],
        is_complete: '',
        student_name: '',
        telphone: '',
        school_id: '',
        school_year: '',
        class_id: '',
        create_time: [],
        student_id: '',
        site_name: 'gkry',
        project_id: 10,
        apply_school_list: [],
        apply_school_ids: [],
        custom_year: '',
        custom_month: '',
        create_uid: ''
      },
      loading: false,
      getListurl: '/finance/order/pagetable', // 表格数据源
    };
  },
  computed: {
  },
  methods: {
    // 重置搜索
    resetFields() {
      this.resetSeachData();
      // console.log(this.searchData);
      this.$store.commit('updateRefresh', true);
    },
    checkTab() {
      if (this.$refs.tableList.loading) {
        return false;
      }
      this.resetSeachData();
    },
    // 切换项目
    tableDataChange(tab) {
      this.searchData = {};
      this.activePid = tab.$attrs['project-id'];
      this.resetFields();
    },
    resetSeachData() {
      switch (this.activeName) {
        case 'gkry':
          this.searchData = this.$refs.gkry.gkryInitSearchData();
          break;
        case 'training':
          this.searchData = this.$refs.training.trainingInitSearchData();
          break;
        case 'jiemo':
          this.searchData = this.$refs.jiemo.initSearchData();
          break;
        case 'qcrb':
          this.searchData = this.$refs.qcrb.initSearchData();
          break;
        case 'nseries':
          this.searchData = this.$refs.nseries.initSearchData();
          break;
        default:
          break;
      }
      this.searchData.site_name = this.activeName;
      this.searchData.project_id = this.activePid;
      this.searchData = Object.assign({}, this.searchData);
    },
    search(params = {}) {
      this.searchData = Object.assign({}, this.searchData, params);
      this.$store.commit('updateRefresh', true);
    },
    schoolFormat(val) {
      let arr = [];
      val.forEach((item) => {
        arr.push(item.sh_name_cn);
      });
      return arr.toString();
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    gkrySearchData,
    trainingSearchData,
    jiemoSearchData,
    qcrbSearchData,
    nseriesSearchData
  },
  mounted() {
    this.$http
      ._post({
        url: '/finance/base/getProjects'
      })
      .then((res) => {
        this.projectList = res.data;
        this.activeName = this.projectList[0].namespace;
        this.searchData.site_name = this.activeName;
        this.searchData.project_id = this.projectList[0].id;
      });
  }
};
</script>
<style scoped>
</style>
